import { t } from 'i18next';
import { ApiErrorCode, IApiErrorParams, IApiErrorWithRejectedRecords } from '@cbridge-packages/api-base';
import { interpolateErrorParams } from '@cbridge-utils/formatters';

export const isErrorWithRejectedRecords = (error: unknown): error is IApiErrorWithRejectedRecords => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'rejectedRecords' in error &&
    Array.isArray((error as IApiErrorWithRejectedRecords).rejectedRecords)
  );
};

export const formatApiErrorMessage = (error: IApiErrorParams | IApiErrorWithRejectedRecords): string => {
  if (isErrorWithRejectedRecords(error)) {
    const messages = error.rejectedRecords.map((record) => {
      const description = interpolateErrorParams(record.errorDescription, record.params);
      return record.name ? `${record.name}: ${description}` : description;
    });
    return messages.join('\n');
  }

  const errorCode = error?.errorCode;
  const description = error?.description;
  const resolvedDescription = description ? interpolateErrorParams(description, error?.params) : description;

  if (errorCode && resolvedDescription) {
    return `${errorCode} - ${resolvedDescription}`;
  }

  if (resolvedDescription) {
    return resolvedDescription;
  }

  if (errorCode && errorCode !== ApiErrorCode.UnknownError) {
    return errorCode;
  }

  return t('text:common.error.somethingWentWrong');
};
